<div class="details-block mt-2">
    <div class="formSection">
        <div class="formSection">
            <div class=" head d-flex">
                <strong>Client Details</strong>
            </div>
        </div>
        <div class="allotment-form">
            <form [formGroup]="formGroup">
                <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12 d-flex">
                    <div class="row form-background" style="padding: 10px;">
                        <div class="form-group col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
                            <div class="form-group">
                                <label>Refrence Name <span class="formMandatoryInput">*</span> </label>
                                <ng-select [(ngModel)]="selectedReference" formControlName="referenceNumber"
                                    (change)="referenceChange($event)" placeholder="Select Reference">
                                    <ng-option value="">Select refrence name</ng-option>
                                    @for (item of referenceList; track item.id) {
                                    <ng-option [value]="item?.id">{{item?.label}}</ng-option>
                                    }
                                </ng-select>
                                <div *ngIf="Submitted && f['referenceNumber'].errors"
                                    style="color: red; font-size: 12px;">
                                    Refrence name is reqiured.
                                </div>
                            </div>
                        </div>
                        <div class="form-group col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
                            <div class="form-group">
                                <label>Source Type <span class="formMandatoryInput">*</span></label>
                                <ng-select formControlName="sourceType" [placeholder]="'Select Source Type'"
                                    (change)="changeSourceType($event)">
                                    <ng-option value="">Select source type</ng-option>
                                    <ng-option *ngFor="let source of allotmentRelatedData?.sourceTypeList"
                                        [value]="source?.id">{{source?.name}}</ng-option>
                                </ng-select>
                                <div *ngIf="Submitted && f['sourceType'].errors" style="color: red; font-size: 12px;">
                                    Source type is reqiured.
                                </div>
                            </div>
                        </div>
                        <div class="form-group col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
                            <div class="form-group">
                                <label>Source Name <span class="formMandatoryInput">*</span></label>
                                <ng-select formControlName="sourceName" [placeholder]="'Select Agent Name'">
                                    <ng-option value="">Select agent name</ng-option>
                                    <ng-option *ngFor="let agent of allotmentRelatedData?.agentList"
                                        [value]="agent.id">{{agent.fullName}}</ng-option>
                                </ng-select>
                                <div *ngIf="Submitted && f['sourceName'].errors" style="color: red; font-size: 12px;">
                                    Source
                                    name is reqiured.
                                </div>
                            </div>
                        </div>
                        <div class="form-group col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
                            <div class="form-group initials">
                                <label>Initial <span class="formMandatoryInput">*</span></label>
                                <ng-select formControlName="nameInitialsId" [placeholder]="'Select Initial'">
                                    <ng-option value="">Select initial</ng-option>
                                    <ng-option *ngFor="let initial of allotmentRelatedData?.nameInitialsList"
                                        [value]="initial?.id">{{ initial?.name}}</ng-option>
                                </ng-select>
                                <div *ngIf="Submitted && f['nameInitialsId'].errors"
                                    style="color: red; font-size: 12px;">
                                    Initial is reqiured.
                                </div>
                            </div>
                        </div>
                        <div class="form-group col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
                            <div class="form-group">
                                <label>First Name <span class="formMandatoryInput">*</span></label>
                                <span style="float: right; cursor: pointer;" *ngIf="showClientIcon"
                                    (click)="toggleClientList()"><img src="{{ customerIcon }}"
                                        class="userIcon" /></span>
                                <input type="text" id="firstName" class="firstName" name="firstName"
                                    formControlName="firstName" class="form-control"
                                    [placeholder]="'Enter First Name'" />
                                <div *ngIf="Submitted && f['firstName'].errors" style="color: red; font-size: 12px;">
                                    First
                                    name is reqiured.
                                </div>
                            </div>
                        </div>
                        <div class="form-group col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
                            <div class="form-group">
                                <label>Last Name </label>
                                <input type="text" id="lastName" class="lastName" name="lastName"
                                    formControlName="lastName" class="form-control" [placeholder]="'Enter Last Name'" />
                            </div>
                        </div>
                        <div class="form-group col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                            <div class="form-group initials">
                                <label>Initial <span class="formMandatoryInput">*</span></label>
                                <ng-select formControlName="relationInitialsId" [placeholder]="'Select Initial'">
                                    <ng-option value="">Select initial</ng-option>
                                    <ng-option *ngFor="let initial of allotmentRelatedData?.relationInitialList"
                                        [value]="initial?.id">{{ initial?.name}}</ng-option>
                                </ng-select>
                                <div *ngIf="Submitted && f['relationInitialsId'].errors"
                                    style="color: red; font-size: 12px;">Initial is reqiured.
                                </div>
                            </div>
                        </div>
                        <div class="form-group col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                            <div class="form-group">
                                <label>Father/Hus. Name <span class="formMandatoryInput">*</span></label>
                                <input type="text" id="parentName" class="parentName" name="parentName"
                                    formControlName="parentName" class="form-control"
                                    [placeholder]="'Enter Parent Name'" />
                                <div *ngIf="Submitted && f['parentName'].errors" style="color: red; font-size: 12px;">
                                    Father/Hus. Name is reqiured.
                                </div>
                            </div>
                        </div>
                        <div class="form-group col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
                            <div class="form-group">
                                <label>Gender <span class="formMandatoryInput">*</span></label>
                                <ng-select formControlName="gender" [placeholder]="'Select Gender'">
                                    <ng-option value="">Select gender</ng-option>
                                    <ng-option [value]="gender?.name"
                                        *ngFor="let gender of this.genders">{{gender?.name}}</ng-option>
                                </ng-select>
                                <div *ngIf="Submitted && f['gender'].errors" style="color: red; font-size: 12px;">Gender
                                    is
                                    reqiured.
                                </div>
                            </div>
                        </div>
                        <div class="form-group col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
                            <div class="form-group">
                                <label>Blood Group</label>
                                <ng-select formControlName="bloodGroup" [placeholder]="'Select Blood Group'">
                                    <ng-option value="">Select blood group</ng-option>
                                    <ng-option [value]="bloodGroup"
                                        *ngFor="let bloodGroup of allotmentRelatedData?.bloodGroupList">{{bloodGroup}}</ng-option>
                                </ng-select>
                            </div>
                        </div>
                        <div class="form-group col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
                            <div class="form-group">
                                <label>Nationality <span class="formMandatoryInput">*</span></label>
                                <ng-select formControlName="nationality" [placeholder]="'Select Nationality'">
                                    <ng-option value="">Select nationality</ng-option>
                                    <ng-option value="Indian">Indian</ng-option>
                                    <ng-option value="NRI">NRI</ng-option>
                                </ng-select>
                                <div *ngIf="Submitted && f['nationality'].errors" style="color: red; font-size: 12px;">
                                    Nationality is reqiured.
                                </div>
                            </div>
                        </div>
                        <div class="form-group col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
                            <div class="form-group">
                                <label for="pan">PAN <span class="formMandatoryInput">*</span></label>
                                <input type="text" id="pan" class="pan" name="pan" formControlName="pan"
                                    class="form-control" [placeholder]="'Enter PAN Number'" />
                                <div *ngIf="pan?.invalid && (pan?.touched || pan?.dirty)" class="text-danger">
                                    <div *ngIf="pan?.errors?.['invalidPan']">Invalid PAN number format.</div>
                                </div>
                                <div *ngIf="Submitted && f['pan'].errors" style="color: red; font-size: 12px;">PAN
                                    number is
                                    reqiured.
                                </div>
                            </div>
                        </div>
                        <!-- <div class="form-group col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
                            <div class="form-group">
                                <label>UID Type <span class="formMandatoryInput">*</span></label>
                                <ng-select formControlName="uidType" [placeholder]="'Select UID Type'">
                                    <ng-option value="">Select UID type</ng-option>
                                    <ng-option [value]="uid.id" *ngFor="let uid of uidTypeList">{{uid.name}}</ng-option>
                                </ng-select>
                                <div *ngIf="Submitted && f['uidType'].errors" style="color: red; font-size: 12px;">UID
                                    type
                                    is reqiured.
                                </div>
                            </div>
                        </div> -->
                        <div class="form-group col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
                            <div class="form-group">
                                <label>Aadhar Number</label>
                                <input type="text" id="aadharNumber" class="form-control aadharNumber"
                                    name="aadharNumber" formControlName="aadharNumber"
                                    [placeholder]="'Enter enter aadhar number'" />
                                <!-- <div *ngIf="Submitted && f['uidNumber'].errors" style="color: red; font-size: 12px;">UID
                                    number is reqiured.
                                </div> -->
                            </div>
                        </div>
                        <div class="form-group col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
                            <div class="form-group">
                                <label for="email"> Email </label>
                                <input type="email" id="email" class="email" name="email" formControlName="email"
                                    class="form-control" [placeholder]="'Enter Email'" />
                                <div *ngIf="email?.invalid && (email?.touched || email?.dirty)" class="text-danger">
                                    <div *ngIf="email?.errors?.['email']">Please enter a valid email address.</div>
                                </div>
                            </div>
                        </div>
                        <div class="form-group col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
                            <div class="form-group">
                                <label> Mobile <span class="formMandatoryInput">*</span></label>
                                <input type="text" id="contactNumber" class="contactNumber"
                                    (keypress)="_keyPress($event)" type="text" maxlength="10" name="contactNumber"
                                    formControlName="contactNumber" class="form-control"
                                    [placeholder]="'Enter Mobile Number'" />
                                <div *ngIf="Submitted && f['contactNumber'].errors"
                                    style="color: red; font-size: 12px;">
                                    Mobile number is reqiured.
                                </div>
                            </div>
                        </div>
                        <div class="form-group col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
                            <div class="form-group">
                                <label> Alternate Number </label>
                                <input type="text" id="secondaryPhoneNo" (keypress)="_keyPress($event)" type="text"
                                    maxlength="10" class="secondaryPhoneNo" name="secondaryPhoneNo"
                                    formControlName="secondaryPhoneNo" class="form-control"
                                    [placeholder]="'Enter Alternate Mobile Number'" />
                            </div>
                        </div>
                        <div class="form-group col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
                            <div class="form-group">
                                <label for="buttondisplay"> Date of Birth </label><span class="formMandatoryInput">
                                    *</span>
                                <div class="d-flex align-items-center">
                                    <p-calendar [(ngModel)]="dateOfBirth" formControlName="dateOfBirth"
                                        dateFormat="dd/mm/yy" [showIcon]="true" inputId="buttondisplay"
                                        [showOnFocus]="false" class="custom-calendar" [placeholder]="'Enter DOB'" />

                                </div>
                                <div *ngIf="Submitted && f['dateOfBirth'].errors" style="color: red; font-size: 12px;">
                                    Date of birth is reqiured.
                                </div>
                            </div>
                        </div>
                        <div class="form-group col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
                            <div class="form-group">
                                <label for="buttondisplay"> Wedding Anniversary </label>
                                <div class="d-flex align-items-center">
                                    <p-calendar [(ngModel)]="anniversaryDate" formControlName="weddingAnniversary"
                                        dateFormat="dd/mm/yy" [showIcon]="true" inputId="buttondisplay"
                                        class="custom-calendar" [showOnFocus]="false"
                                        [placeholder]="'Enter Anniversary Date'" />
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </form>
        </div>
    </div>

    <!--paymen details tab-->
    <div>
        <div class="details-block mt-2">
            <div class="formSection">
                <div class="head d-flex">
                    <strong>Unit Details</strong>
                </div>
            </div>
            <div class="allotment-form" *ngIf="formGroup">
                <form [formGroup]="formGroup">
                    <div class="form-background" style="padding: 10px;">
                        <div class="row">
                            <div class="form-group col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
                                <div class="form-group">
                                    <label> Unit Category <span class="formMandatoryInput">*</span></label>
                                    <ng-select formControlName="unitCategory" [(ngModel)]="selectedUnitCategory"
                                        (change)="onChangeUnitCategory($event)" [placeholder]="'Select Unit Category'">
                                        <ng-option value="">Select unit category</ng-option>
                                        <ng-option *ngFor="let unit of allotmentRelatedData?.unitCategoryList"
                                            [value]="unit?.id">{{unit?.name}}</ng-option>
                                    </ng-select>
                                    <div *ngIf="Submitted && f['unitCategory'].errors"
                                        style="color: red; font-size: 12px;">
                                        Unit category is reqiured.
                                    </div>
                                </div>
                            </div>
                            <div class="form-group col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
                                <div class="form-group">
                                    <label> Unit No. <span class="formMandatoryInput">*</span></label>
                                    <ng-select formControlName="unitDescription"
                                        [placeholder]="'Select Unit Description'"
                                        (change)="onChangeUnitDescription($event)" [(ngModel)]="selectedUnitDescription"
                                        disable="{{ !filteredUnitDescriptions.length }}">
                                        <ng-option value="">Select unit No.</ng-option>
                                        <ng-option *ngFor="let description of filteredUnitDescriptions"
                                            [value]="description?.id">
                                            {{ description?.name }}
                                        </ng-option>
                                    </ng-select>
                                    <div *ngIf="Submitted && f['unitDescription'].errors"
                                        style="color: red; font-size: 12px;">
                                        Unit No. is reqiured.
                                    </div>
                                </div>
                            </div>
                            <div class="form-group col-sm-12 col-md-4 col-lg-4 col-xl-4">
                                <div class="form-group">
                                    <label>Tax Structure <span class="formMandatoryInput">*</span></label>
                                    <ng-select formControlName="taxStructure" [(ngModel)]="selectedTaxName"
                                        (change)="onChangeTaxStructure()" [placeholder]="'Select Tax Structure'">
                                        <ng-option value="">Select tax structure</ng-option>
                                        <ng-option class="form-control" [value]="taxSubType?.id"
                                            *ngFor="let taxSubType of allotmentRelatedData?.taxSubTypeList">{{taxSubType?.name}}</ng-option>
                                    </ng-select>
                                    <div *ngIf="Submitted && f['taxStructure'].errors"
                                        style="color: red; font-size: 12px;">
                                        Tax structure is reqiured.
                                    </div>
                                </div>
                            </div>
                            <div class="form-group col-sm-12 col-md-4 col-lg-4 col-xl-4">
                                <div class="form-group">
                                    <label>Payment Plan <span class="formMandatoryInput">*</span></label>
                                    <ng-select formControlName="paymentPlan" (change)="onChangePaymentPlan($event)"
                                        [placeholder]="'Select Payment Plan'">
                                        <ng-option class="form-control" value="-1">Select payment plan</ng-option>
                                        <ng-option *ngFor="let paymentPlan of allotmentRelatedData?.paymentPlanList"
                                            [value]="paymentPlan?.id">{{paymentPlan?.name}}</ng-option>
                                    </ng-select>
                                    <div *ngIf="Submitted && f['paymentPlan'].errors"
                                        style="color: red; font-size: 12px;">
                                        Payment plan is reqiured.
                                    </div>
                                </div>
                            </div>
                            <div class="form-group col-sm-12 col-md-4 col-lg-4 col-xl-4">
                                <div class="form-group">
                                    <label>Basic Sale Price </label><span class="formMandatoryInput">
                                        *</span>
                                    <input type="text" id="saleRate" class="saleRate" readonly
                                        [(ngModel)]="defaultbasicSalePrice" name="saleRate" formControlName="saleRate"
                                        class="form-control" />
                                </div>
                            </div>
                            <div class="form-group col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
                                <div class="form-group">
                                    <label for="buttondisplay">Date Of Booking </label> <span
                                        class="formMandatoryInput">
                                        *</span>
                                    <div class="d-flex align-items-center">
                                        <p-calendar [(ngModel)]="bookingDate" [maxDate]="maxDate" appendTo="body"
                                            formControlName="bookingDate" dateFormat="dd/mm/yy" [showIcon]="true"
                                            inputId="buttondisplay" [showOnFocus]="false" class="custom-calendar"
                                            [placeholder]="'Enter Booking Date'"
                                            (onSelect)="onChangeBookingDate($event)" />
                                    </div>
                                    <div *ngIf="Submitted && f['bookingDate'].errors"
                                        style="color: red; font-size: 12px;">Booking date is reqiured.
                                    </div>
                                </div>
                            </div>
                            <div class="form-group col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
                                <div class="form-group">
                                    <label for="buttondisplay">Date Of Allotment </label><span
                                        class="formMandatoryInput">
                                        *</span>
                                    <div class="d-flex align-items-center">
                                        <p-calendar [(ngModel)]="allotmentDate" [maxDate]="maxDate" appendTo="body"
                                            formControlName="allotmentDate" dateFormat="dd/mm/yy" [showIcon]="true"
                                            inputId="buttondisplay" [showOnFocus]="false" class="custom-calendar"
                                            [placeholder]="'Enter Allotement Date'"
                                            (onSelect)="onChangeAllotmentDate($event)" />
                                    </div>
                                    <div *ngIf=" Submitted && f['allotmentDate'].errors"
                                        style="color: red; font-size: 12px;">Allotement date is reqiured.
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>

        <!-- Charges Section -->
        <div class="details-block">
            <!-- Charges table Section Starts here-->
            <div class="formSection">
                <div class="head d-flex">
                    <strong>Charges</strong>
                    <div class="icon-section" [class.disabled]="isDisabledCharges">
                        <img src="../../../../../assets/images/addImageIcon.svg" style="width: 14px;"
                            (click)="!isDisabledCharges && addNewOtherChargesRecord()">&nbsp;
                    </div>
                </div>
            </div>
            <div>
                <app-common-table [columnDefs]="otherChargesColumnDefs" [showSearchBar]="!hideSearchBar"
                    [data]="otherChargesRowData" (rowAction)="handleRowAction($event)"></app-common-table>
            </div>
            <!-- Charges table Section Ends here-->

            <!-- Charges Table (to edit n view charges detail on popup) Start here  -->
            <p-dialog header="Charges" [closeOnEscape]="false" [(visible)]="showOtherChargesModal" [modal]="true"
                (onHide)="closeOtherChargesModal()" [responsive]="true" [style]="{width: '50vw'}">
                <div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                    <div class="table-responsive">
                        <form [formGroup]="otherChargeForm">
                            <table class="table head form-background">
                                <thead>
                                    <tr>
                                        <th class="chargeTableheader"> Heads</th>
                                        <th> At Rate</th>
                                        <th> No. Of Units</th>
                                        <th> Amount</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>
                                            <ng-select [disabled]="isEditOtherRow" [class.disabled]="isEditOtherRow"
                                                style="width: 90%;" (change)="onChangeOtherChargesHead($event)"
                                                formControlName="amountSubType">
                                                <ng-option class="form-control" value="">Select amount sub
                                                    type</ng-option>
                                                <ng-option class="form-control"
                                                    *ngFor="let sub of eligibleAmountSubTypeList"
                                                    [value]="sub?.id">{{sub?.name}}
                                                </ng-option>
                                            </ng-select>
                                            <div *ngIf="OtherFormSubmitted && fo['amountSubType'].errors"
                                                style="color: red; font-size: 12px;">
                                                Amount sub type is reqiured.
                                            </div>
                                        </td>
                                        <td>
                                            {{ selectedOtherChargeAmountRate | indianCurrency}}
                                            <!-- {{selectedNonMandatoryOtherChargesHead?.selectedAmountType=='Percentage'?'%':''}} -->
                                        </td>
                                        <td>
                                            <div class="row d-flex"
                                                *ngIf="selectedNonMandatoryOtherChargesHead?.isMultiple">
                                                <div class="form-group col-md-6">
                                                    <input style="width: 100%; text-align: left;" type="number"
                                                        class="form-control" (change)="isMultipleChange()" />
                                                </div>
                                            </div>
                                        </td>
                                        <td>
                                            {{selectedOtherChargesHead | indianCurrency }}
                                        </td>
                                    </tr>
                                    <ng-container formArrayName="allDiscounts" *ngIf="discounts.controls.length > 0">
                                        <tr *ngFor="let disc of discounts.controls; let i = index" [formGroupName]="i">
                                            <td><label>Discount (max: ₹ {{this.eligibleDiscountList[i]?.maxDiscount}}/-)
                                                </label>
                                                <div><b class="discount-name">{{this.eligibleDiscountList[i]?.name}}</b>
                                                </div>
                                            </td>
                                            <td>
                                                <div class="row d-flex">
                                                    <div class="form-group col-md-6">
                                                        <input style="width: 100%; text-align: left;"
                                                            id="discountAmount" formControlName="discountRate"
                                                            type="number" class="form-control"
                                                            (change)="discountChange(disc,i)" />
                                                    </div>
                                                    <div class="form-group col-md-6">
                                                        {{ this.eligibleDiscountList[i]?.discountFrequency ==
                                                        'Amount'?'Rs.':'%.' }}
                                                        /
                                                        {{this.eligibleDiscountList[i]?.discountUnit}}
                                                    </div>
                                                </div>
                                            </td>
                                            <td></td>
                                            <td class="text-align">
                                                {{ disc.get('discountAmount')?.value | indianCurrency }}
                                            </td>
                                        </tr>
                                    </ng-container>
                                    <tr>
                                        <td><label>Tax Structure</label></td>
                                        <td></td>
                                        <td colspan="2">
                                            <ng-select formControlName="otherTaxType" (change)="otherTaxChange($event)">
                                                <ng-option class="form-control"
                                                    *ngFor="let taxSubType of allotmentRelatedData?.taxSubTypeList"
                                                    [value]="taxSubType?.id">{{taxSubType?.name}}</ng-option>
                                            </ng-select>
                                            <div *ngIf="OtherFormSubmitted && fo['otherTaxType'].errors"
                                                style="color: red; font-size: 12px;">
                                                Tax structure is reqiured.
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td><label>Taxable Amount</label></td>
                                        <td class="text-align">
                                            {{selectedNonMandatoryOtherChargesHead?.amountUnit}}
                                        </td>
                                        <td></td>
                                        <td class="text-align">
                                            {{taxableAmount| indianCurrency}}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td><label>CGST</label></td>
                                        <td class="text-align">
                                            {{dividedRateOfTaxStructure | indianCurrency }} %
                                        </td>
                                        <td></td>

                                        <td class="text-align">
                                            {{cgstValue | indianCurrency}}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td><label>SGST</label></td>
                                        <td class="text-align">
                                            {{dividedRateOfTaxStructure | indianCurrency }} %
                                        </td>
                                        <td></td>
                                        <td class="text-align">
                                            {{sgstValue | indianCurrency}}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td><label>IGST</label></td>
                                        <td><input formControlName="igstRate" type="number" class="form-control"
                                                (change)="onIgstChange($event)" /></td>
                                        <td></td>

                                        <td class="text-align">{{igstValue | indianCurrency}}</td>
                                    </tr>
                                    <tr>
                                        <td><label>Tax Amount</label></td>
                                        <td></td>
                                        <td></td>
                                        <td class="text-align">
                                            {{this.cgstValue + this.sgstValue + igstValue | indianCurrency}}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td><label>Gross Amount</label></td>
                                        <td></td>
                                        <td></td>
                                        <td class="text-align">
                                            {{grossAmount | indianCurrency}}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td><label>Round Off</label></td>
                                        <td></td>
                                        <td></td>
                                        <td class="text-align">{{roundOffGrossAmount | indianCurrency}}</td>
                                    </tr>
                                    <tr>
                                        <td><label>Net Amount</label></td>
                                        <td></td>
                                        <td></td>
                                        <td class="text-align"> {{totalAmount | indianCurrency}}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </form>
                    </div>
                </div>
                <p-footer>
                    <button label="Submit" class="btn btn-success mr-2" (click)="submitOtherChargesData()"
                        [disabled]="isSubmitDisabled">Submit</button>
                    <button label="Submit" class="btn btn-danger mr-4"
                        (click)="closeOtherChargesModal()">Cancel</button>
                </p-footer>
            </p-dialog>
            <!-- Charges table end here -->
        </div>

        <!-- Payment Schedule Section -->
        <div class="details-block" style="background-color: white;">
            <div class="formSection">
                <div class=" head d-flex">
                    <strong>Payment Schedule</strong>
                </div>
            </div>
            <div>
                <app-common-table [showSearchBar]="!hideSearchBar" [columnDefs]="paymentScheduleColumnDefs"
                    [data]="currentPaymentScheduledDataRows"></app-common-table>
            </div>
        </div>

        <!-- Footer -->
        <div class="">
            <div class="row head d-flex m-0" *ngIf="allotmentRelatedData?.currentRecord?.id>0">
                <div class="col-md-3 text-center">
                    <strong>Prepared By</strong>
                </div>
                <div class="col-md-3 text-center">
                    <strong>Prepared On</strong>
                </div>
                <div class="col-md-3 text-center">
                    <strong>Approved By</strong>
                </div>
                <div class="col-md-3 text-center">
                    <strong>Approved On</strong>
                </div>
            </div>
            <div *ngIf="allotmentRelatedData?.currentRecord?.id>0">
                <div class="row d-flex">
                    <div class="col-md-3 text-center pt-3">
                        <strong class="displayUserNames"></strong>
                    </div>
                    <div class="col-md-3 text-center pt-3">
                        <strong class="displayUserNames"></strong>
                    </div>
                    <div class="col-md-3 text-center pt-3">
                        <strong class="displayUserNames"></strong>
                    </div>
                    <div class="col-md-3 text-center pt-3">
                        <strong class="displayUserNames"></strong>
                    </div>
                </div>

            </div>

            <div class="row">
                <div class="col-md-6 redirectButtonDiv">
                    <div data-toggle="modal" class="d-flex" data-target="#allotmentBasicDetailTab">
                        <div class="back-actionbutton-icon">
                            <img src="assets/images/backicon.svg" aria-hidden="true" class="moveIcon">
                        </div>
                        <div class="back-actionbutton-text ">Back</div>
                    </div>
                </div>
                <div class="col-md-6 d-flex actionButtonDiv">
                    <button type="submit" class="btn btn-approve mr-2">Request to Approve</button>
                    <button type="submit" class="btn btn-approve mr-2">Request to Edit</button>
                    <button id="btnSubmitBasicDetails" type="submit" class="btn btn-submit-allotment mr-2"
                        (click)="submit()">Submit</button>
                    <div data-toggle="modal" class="d-flex" data-target="#allotmentBasicDetailTab">
                        <div class="next-actionbutton-text ">Next</div>
                        <div class="next-actionbutton-icon">
                            <img src="assets/images/nexticon.svg" aria-hidden="true" class="moveIcon">
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>


    <!-- Client List modal -->
    <p-dialog [(visible)]="showOverlay" [modal]="true" [closeOnEscape]="false" [draggable]="false" [resizable]="true"
        *ngIf="showOverlay" [style]="{ height: 'auto' }">
        <ng-template pTemplate="header">
            <h5>Client List</h5>
        </ng-template>
        <div>
            <app-common-list (setValues)="setSelecetedCustomer($event)" [columns]="columns" [rowSelection]="'single'"
                [suppressContextMenu]="true" [gridData]="clientList" (hideModal)="toggleClientList()"></app-common-list>
        </div>
    </p-dialog>

    <!-- Common form for co applicant -nominee or family details -->
    <p-dialog [(visible)]="showDetailedModal" [closeOnEscape]="false" [modal]="true" [draggable]="false"
        [resizable]="false" *ngIf="showDetailedModal" [style]="{ height: '25rem', width:'50rem'}">
        <ng-template pTemplate="header">
            <h6>{{formIdentity}}</h6>
        </ng-template>
        <div>
            <app-common-form [identity]="formIdentity" [commonFormData]="coApplicantDetailsConfig"
                (formSubmit)="onCommonFormSubmit($event)" (hideModal)="hideCommonFormModal()"
                [suppressContextMenu]="true"></app-common-form>
        </div>
    </p-dialog>